import React, { Component, Fragment } from 'react'
import { Layout } from 'app/common/layout'
import type {
    Banner as TypeBanner,
    CategoryWithProductsDTO
} from 'shared/types'
import { CategoryWithProducts } from './CategoryWithProducts'
import type { ECommerceMetadata, EventMetadata } from 'shared/store/metadata'
import { ErrorManagement } from 'app/common/error-management'
import type { MenuListItem } from 'app/common/layout/menu'
import { MenuLayout, MenuWithTiles } from 'app/common/layout/menu'
import { Placeholder } from 'app/common/placeholder'
import { Banner } from './Banner'
import styled from 'styled-components'
import Confetti from 'react-confetti'
import { colors } from 'shared/assets/styles'

const { lightMayo } = colors

type Props = {
    fetchPageData: () => void,
    resetCategoryWithProducts: () => void,
    applySelectedAllergens: (Array<string>) => void,
    getProductsByCategoryId: (categoryId: string) => void,
    categories: Array<MenuListItem>,
    categoryWithProducts: CategoryWithProductsDTO,
    selectedAllergens: Array<string>,
    sendMeta: EventMetadata => void,
    sendECommerceMeta: ECommerceMetadata => void,
    error: any,
    networkError: any,
    dataLoaded: boolean,
    banner?: TypeBanner,
    match: any,
    location: any
}

type State = {
    showConfettis: boolean
}

class CatalogComponent extends Component<Props, State> {
    constructor(props: Props) {
        super()
        const { search } = props.location
        const param = search.split('anim=')
        const showConfettis = param[1] === 'true'
        this.state = {
            showConfettis: !!showConfettis && !props.match.params.categoryId
        }
    }

    componentDidMount() {
        const { match, fetchPageData, getProductsByCategoryId } = this.props
        const categoryId = match.params.categoryId
        fetchPageData()

        categoryId && getProductsByCategoryId(categoryId)
        setTimeout(this.hideConfettis, 8000)
    }

    componentDidUpdate(prevProps: Props) {
        const { match, getProductsByCategoryId } = this.props
        const categoryId = match.params.categoryId
        const prevCategoryId = prevProps.match.params.categoryId
        if (prevCategoryId !== categoryId) {
            categoryId && getProductsByCategoryId(categoryId)
        }
    }

    hideConfettis = () => this.setState({ showConfettis: false })

    render() {
        const {
            categories,
            match,
            categoryWithProducts,
            sendMeta,
            sendECommerceMeta,
            error,
            networkError,
            resetCategoryWithProducts,
            dataLoaded,
            banner,
            ...otherProps
        } = this.props
        const { showConfettis } = this.state
        const categoryId = match.params.categoryId
            ? match.params.categoryId
            : false

        return (
            <ErrorManagement error={error} networkError={networkError}>
                <Layout border={true} background="plain">
                    <MenuLayout
                        menuItems={categories}
                        hideMobileMenu={categoryId}
                        sendMeta={sendMeta}
                        route="routes.catalog"
                        menuTitle="catalog.list.label"
                        background={lightMayo}>
                        <Fragment>
                            {categoryId ? (
                                categoryWithProducts ? (
                                    <CategoryWithProducts
                                        categoryWithProducts={
                                            categoryWithProducts
                                        }
                                        sendMeta={sendMeta}
                                        sendECommerceMeta={sendECommerceMeta}
                                        resetCategoryWithProducts={
                                            resetCategoryWithProducts
                                        }
                                        {...otherProps}
                                    />
                                ) : (
                                    <Placeholder
                                        minHeightDesktop="100vh"
                                        minHeightMobile="100vh"
                                    />
                                )
                            ) : (
                                <MenuWithTiles
                                    tiles={categories}
                                    titleKey="catalog.card.title"
                                    descriptionKey="catalog.card.description"
                                    breadcrumbKey="catalog.card.title.breadcrumb.end"
                                    propRoute="routes.catalog"
                                    topChild={
                                        banner && (
                                            <BannerContainer>
                                                <Banner {...banner} />
                                            </BannerContainer>
                                        )
                                    }
                                    isCategories
                                />
                            )}
                        </Fragment>
                    </MenuLayout>
                    {showConfettis && (
                        <Overlay onClick={this.hideConfettis}>
                            <Confetti numberOfPieces={500} />
                        </Overlay>
                    )}
                </Layout>
            </ErrorManagement>
        )
    }
}

const BannerContainer = styled.div`
    margin-bottom: 16px;
`

const Overlay = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    cursor: pointer;
`

export { CatalogComponent }
